import { atom } from 'recoil';
export const addPaymentInfo = atom({
    key: 'addPaymentInfo',
    default: {
        isLoading: false,
        useBillingAddress: false,
        suscriptionId: 'Schools & Beyond',
        suscriptionIdError: '',
        isFormInvalid: null
    }
});
